import type { CartTicketInfo } from 'context/CartContext/types';
import type { CalculatePriceTicket } from 'api/requestTypes';

/**
 * Converts CartTicketInfo array to CalculatePriceTicket array format required by the API
 * @param tickets - Array of cart tickets from CartContext
 * @returns Array of tickets in CalculatePriceTicket format
 */
export const mapCartTicketsToCalculatePriceTickets = (
  tickets: CartTicketInfo[],
): CalculatePriceTicket[] => {
  return tickets.map((ticket) => ({
    categoryKey: ticket.categoryKey,
    price: ticket.price,
    category: {
      key: ticket.categoryKey,
      label: ticket.category,
    },
    ...(ticket.ticketType && { ticketType: ticket.ticketType }),
  }));
};
